import { servicesRoutes } from "consts/Routes-App";

/**
 * Los tramos del breadcrumb de una URL, leidos del MENU.
 *
 * La jerarquia no se declara en ningun lado nuevo: `servicesRoutes` ya la tiene y el router de
 * App.jsx la espeja 1:1, asi que `/servicio/RNSALUD/estructuras/zonas` se puede recorrer como
 * arbol y salen los tres tramos solos.
 *
 * Por eso se deriva en vez de que cada vista escriba su titulo a mano: eran 23 strings sueltos
 * que ya habian divergido del menu —el menu decia "Divisiones" y el header "Division - Programa
 * Salud RN", el menu "Zonas Sanitarias" y el header "Zonas - Programa Salud RN"— y cada modulo
 * nuevo sumaba uno mas. Derivandolo, agregar una vista al menu alcanza para que el header la
 * nombre igual.
 *
 * @param pathname  la ruta actual, tal cual la da `useLocation`.
 * @param servicios los servicios autorizados, de donde sale el nombre del primer tramo: el
 *                  menu tiene el codigo (RNSALUD) y el back el nombre (Programa Salud RN).
 * @returns los tramos de mayor a menor, o `null` si la ruta no es de un servicio. Ese `null` es
 *          lo que deja al Header caer al titulo de siempre en Dashboard o Usuarios globales.
 */
export const tramosDeLaRuta = (pathname, servicios = []) => {
    const segmentos = (pathname ?? "").split("/").filter(Boolean);

    // Todo lo que cuelga de un servicio vive bajo /servicio/<cod>. Lo que no, no tiene arbol
    // del que sacar tramos.
    if (segmentos[0] !== "servicio" || !segmentos[1]) return null;

    const [, servicioCod, ...resto] = segmentos;
    const servicio = servicios.find((s) => s.servicioCod === servicioCod);

    // El codigo como ultimo recurso: si los servicios todavia no llegaron, es preferible
    // "RNSALUD > Estructura > Zonas Sanitarias" a un tramo vacio.
    const tramos = [servicio?.servicioNombre ?? servicioCod];

    let nivel = servicesRoutes[servicioCod] ?? [];
    for (const segmento of resto) {
        const item = nivel.find((entrada) => entrada.route === `/${segmento}`);

        // Una ruta que existe en el router pero no en el menu —un modulo comentado como
        // agentes, una futura vista de detalle— no se puede nombrar desde el arbol. Se
        // devuelve `null` y no el camino a medias: quedarse en "Programa Salud RN" dice menos
        // que el titulo que esa vista ya escribe, asi que es mejor dejarsela a ella.
        if (!item) return null;

        tramos.push(item.wordKey);
        nivel = item.routes ?? [];
    }

    return tramos;
};
